'use client';
import React, { Component } from 'react';

import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Complex from '../reusable-components/layouts-components__linkbuilder/complex';
import Process from '../reusable-components/layouts-components__linkbuilder/tasks';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import FullBlueContent from '../reusable-components/layouts-components__linkbuilder/full-blue-content';
import HowWork from '../reusable-components/layouts-components__linkbuilder/how-work';
import Algoritm from '../reusable-components/layouts-components__linkbuilder/algoritm';
import System from '../reusable-components/layouts-components__linkbuilder/system';

import './style.sass';
import '../reusable-components/style.sass';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const linkbuilderMainTitle = {
    titleMainText: `Linkbuilder.Ai: как ИИ меняет правила игры на рынке линкбилдинга`,
    titleAnimation: '/images/svg/linkbuilder/linkbuilder.png',
    subtitleContainer: [
        {
            modeText: 'Отрасль',
            colorMode: '#00B9FF',
            nameText: 'Технологии',
        },
        {
            modeText: 'Технологии',
            colorMode: '#00B9FF',
            nameText: 'Big Data, AI',
        },
    ],
};

const nextProjectlinkbuilder = {
    product: true,
    nextProjectTitle: 'Создание и запуск платформы Onlineconvertfree.com',
    nextProjectImg: '/images/pic/preview/converter.png',
    nextProjectLink: '/cases/products/converter',
    nextProjectLinkTitle: 'Onlineconvertfree.com',
    nextProjectText:
        'Запустили собственную платформу для конвертации файлов, которая поддерживает 231 формат и 2600 направлений, входит в топ-5 конвертеров в мире с аудиторией 2 млн человек из 220 стран ежемесячно',
};

class Linkbuilder extends Component {
    render() {
        return (
            <section className="linkbuilder">
                <div className="linkbuilder__title-wrap">
                    <MainTitle MainTitle={linkbuilderMainTitle} />
                </div>

                <Complex />

                <FullBlueContent />

                <Process />

                <HowWork />

                <Algoritm />

                <System />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectlinkbuilder} />
            </section>
        );
    }
}

export default Linkbuilder;
